import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import leaverForm from './modules/leaverForm';
const persisted = createPersistedState({
    paths: ['profile'],
});
const store = createStore({
    modules: {
        leaverForm,
    },
    plugins: [persisted],
    state() {
        return {
            profile: {},
            theme: {},
            isLoading: false,
            notification: {
                visible: false,
                type: null,
                title: null,
                message: null,
            },
        };
    },
    getters: {
        getProfile(state) {
            return state.profile;
        },
        getTheme(state) {
            return state.theme;
        },
        getNotification(state) {
            return state.notification;
        },
        isLoading(state) {
            return state.isLoading;
        },
    },
    mutations: {
        setProfile(state, value) {
            state.profile = value;
        },
        SET_THEME(state, theme) {
            state.theme = { value: theme };
            localStorage.theme = theme;
        },
        setIsLoading(state, value) {
            state.isLoading = value;
        },
        setNotificationAll(state, payload) {
            state.notification.visible = payload.visible;
            state.notification.type = payload.type;
            state.notification.title = payload.title;
            state.notification.message = payload.message;
        },
    },
    actions: {
        setProfile({ commit }, value) {
            commit('setProfile', value);
        },
        initTheme({ commit }) {
            const cachedTheme = localStorage.theme ? localStorage.theme : false;
            const userPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            if (cachedTheme) {
                commit('SET_THEME', cachedTheme);
            }
            else if (userPrefersDark) {
                commit('SET_THEME', 'dark');
            }
            else {
                commit('SET_THEME', 'light');
            }
        },
        toggleTheme({ commit }) {
            switch (localStorage.theme) {
                case 'light':
                    commit('SET_THEME', 'dark');
                    break;
                default:
                    commit('SET_THEME', 'light');
                    break;
            }
        },
        setIsLoading({ commit }, value) {
            commit('setIsLoading', value);
        },
        setNotificationAll({ commit }, data) {
            commit('setNotificationAll', data);
        },
        closeNotification({ commit }) {
            commit('setNotificationAll', {
                visible: false,
                type: null,
                title: null,
                message: null,
            });
        },
    },
});
export default store;
